import { del, get, post, put, postFormData } from "./api_helper";

import * as url from "./url_helper";

export const getLogging = (data) => post(url.LOGIN, data);
export const logout = (data) => post(url.LOGOUT, data);
export const forgetPassword = (data) => post(url.FORGET_PASSWORD, data);
export const resetPassword = (token, data) =>
  post(`${url.RESET_PASSWORD}?token=${token}`, data);

//profile
export const updateProfile = (data) => put(url.PROFILE, data);

//change password
export const changePassword = (data) => put(url.PASS_CHANGE, data);
//sub-distributor
export const createSubDistributor = (data) => post(url.SUB_DISTRIBUTOR, data);
export const getSubDistributorList = (filters) =>
  get(url.SUB_DISTRIBUTOR, filters);
export const getSubDistributor = (id) => get(`${url.SUB_DISTRIBUTOR}/${id}`);
export const updateSubDistributor = (id, data) =>
  put(`${url.SUB_DISTRIBUTOR}/${id}`, data);
export const updateSubDistributorStatus = (id, data) =>
  put(`${url.SUB_DISTRIBUTOR}/status/${id}`, data);
export const deleteSubDistributor = (id) => del(`${url.SUB_DISTRIBUTOR}/${id}`);

//account
export const createBankAccount = (data) => post(url.ACCOUNT, data);
export const getBankAccountList = (filters) => get(url.ACCOUNT, filters);
export const getTotalBalance = () => get(url.ACCOUNT + "/total-balance");
export const updateAccountStatus = (id, data) =>
  put(`${url.ACCOUNT}/status/${id}`, data);
export const getAccountDetails = (id) => get(`${url.ACCOUNT}/${id}`);
export const getAccountTransactions = (id, filters) =>
  get(`${url.ACCOUNT}/transactions/${id}/`, filters);
export const depositAmount = (data) =>
  post(`${url.ACCOUNT}/amount/deposit`, data);
export const transferAmount = (data) =>
  post(`${url.ACCOUNT}/amount/transfer`, data);
export const withdrawAmount = (data) =>
  post(`${url.ACCOUNT}/amount/withdraw`, data);
export const updateAccount = (data, id) => put(`${url.ACCOUNT}/${id}`, data);
export const deleteAccount = (id) => del(`${url.ACCOUNT}/${id}`);

//loan
export const createLoan = (data) => post(url.LOAN, data);
export const getLoanList = (filters) => get(url.LOAN, filters);
export const getLoan = (id) => get(`${url.LOAN}/${id}`);
export const updateLoan = (id, data) => put(`${url.LOAN}/${id}`, data);
export const deleteLoan = (id) => del(`${url.LOAN}/${id}`);
export const getLoanUserByAadharAndPan = (aadharCard, panCard = null) => get(`${url.LOAN}/user/${aadharCard}${panCard ? `/${panCard}` : ''}`);
export const getLoanUsers = () => get(`${url.LOAN}/users`);
export const getLoanBillNo = () => get(`${url.LOAN}/next-bill-number`);
export const downloadLoanApplication = (id) => get(`${url.LOAN}/${id}/contract-pdf`, {}, { responseType: 'blob' });
export const downloadForm11 = (id) => get(`${url.LOAN}/${id}/form-11-pdf`, {}, { responseType: 'blob' });

//deposit (loan repayment)
export const getDepositList = (filters) => {
  return get(`${url.LOAN}/deposit`, filters)
};
export const createDeposit = (data) => post(`${url.LOAN}/deposit`, data);
export const getNextDepositReceiptNumber = () => get(`${url.LOAN}/next-receipt-number`);
export const downloadForm12 = (id) => get(`${url.LOAN}/deposit/${id}/form-12-pdf`, {}, { responseType: 'blob' });

//upload
export const uploadFile = (formData) => postFormData(url.UPLOAD, formData);

//terms & conditions
export const getTermsConditions = () => get(url.TERMS_CONDITIONS);
export const saveTermsConditions = (data) => post(url.TERMS_CONDITIONS, data);

//business detail
export const getBusinessDetail = () => get(url.BUSINESS_DETAIL);
export const updateBusinessDetail = (data) => put(url.BUSINESS_DETAIL, data);

//expenses
export const getExpenseList = (filters) => get(url.EXPENSE, filters);
export const getExpense = (id) => get(`${url.EXPENSE}/${id}`);
export const createExpense = (data) => post(url.EXPENSE, data);
export const updateExpense = (id, data) => put(`${url.EXPENSE}/${id}`, data);
export const deleteExpense = (id) => del(`${url.EXPENSE}/${id}`);
export const getExpenseCategory = () => get(`${url.EXPENSE}/category`);
export const createExpenseCategory = (data) => post(`${url.EXPENSE}/category`, data);
